import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FolderOpen } from "lucide-react";
import { getBlogCategories } from "../lib/supabase";

export default function CategoryIndex() {
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCategories() {
      try {
        setLoading(true);
        const data = await getBlogCategories();
        setCategories(data);
      } catch (err) {
        console.error("Error fetching categories:", err);
        setError("Failed to load categories");
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#F98B3D]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-md">
        <p className="text-red-700">{error}</p>
      </div>
    );
  }

  return (
    <div>
      <h1 className="blog-title">Categories</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={`/blog/category/${category.slug}`}
            className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow duration-200"
          >
            <div className="flex items-center mb-4">
              <FolderOpen className="h-6 w-6 text-[#F98B3D] mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">
                {category.name}
              </h2>
            </div>
            {category.description && (
              <p className="text-gray-600">{category.description}</p>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}
